import type { ReactNode } from 'react';

/** A bordered list of {@link SettingRow}s. Each direct child is padded as one row. */
export function SettingList({ children }: { children: ReactNode }) {
  return (
    <div className="divide-y divide-spark-border-subtle rounded-lg border border-spark-border-subtle [&>*]:p-4">
      {children}
    </div>
  );
}
